var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNodata = function SvgNodata(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 41,
    viewBox: "0 0 64 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 25C22 24.4477 22.4477 24 23 24H29C29.5523 24 30 24.4477 30 25V40H22V25Z",
    fill: "#B6C2D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 33C10 32.4477 10.4477 32 11 32H17C17.5523 32 18 32.4477 18 33V40H10V33Z",
    fill: "#B6C2D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 16.4477 34.4477 16 35 16H41C41.5523 16 42 16.4477 42 17V40H34V17Z",
    fill: "#B6C2D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 9C46 8.44772 46.4477 8 47 8H53C53.5523 8 54 8.44772 54 9V40H46V9Z",
    fill: "#B6C2D6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 40,
    width: 56,
    height: 1,
    fill: "#B6C2D6"
  })));
};
export default SvgNodata;